import { AxiosInstance } from 'axios'
import { useAppStore } from '@/store/app'

export function setupAutoUpdateToken(axios: AxiosInstance) {
  const wait = (ms: number) => new Promise(res => setTimeout(res, ms))
  axios.interceptors.response.use(
    function (res) {
      // console.info(
      //     `Method=${res.config.method} URL=${res.config.url} Code=${res.status}`
      // )
      return res
    },
    async function axiosRetryInterceptor(err) {
      const store = useAppStore()

      if (err.config && err.response && err.response.status === 401) {
        if (store.handshake && typeof store.handshake.then === 'function') {
          store.handshake.then(parent => {
            parent.emit('refresh-token')
          })
        }
        const retryCount = store.requestRetryCount

        if (retryCount >= 5) {
          store.updateRequestRetryCount(0)
          return Promise.reject(err)
        }
        await wait(2 ** retryCount * 10) // exponential back off time. -> wait for token
        store.updateRequestRetryCount(retryCount + 1)
        return axios.request(err.config)
      }
      return Promise.reject(err)
    }
  )
}
